// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__119Eu","sendOtp":"AuthorizeToLogin_sendOtp__27JdR"};